import { Record } from 'immutable';
import { EntityTypes } from '../schemas';

export default class ResourceRecord extends Record({
  id: undefined,
  type: EntityTypes.Resource,
  address: undefined,
  age: undefined,
  areas: undefined,
  availableDates: undefined,
  availableWeeksString: undefined,
  bankAccountNumber: undefined,
  bankGiro: undefined,
  bankName: undefined,
  basicSchema: undefined,
  bic: undefined,
  birthDate: undefined,
  bookedPeriods: undefined,
  companyName: undefined,
  createdAt: undefined,
  deletedAt: undefined,
  employmentNumbers: undefined,
  extra: undefined,
  files: undefined,
  firstName: undefined,
  fortnoxSettings: undefined,
  gdprAcceptedAt: undefined,
  hosp: undefined,
  iban: undefined,
  information: undefined,
  ivo: undefined,
  lastInteractionEvent: undefined,
  lastName: undefined,
  lastRecruitmentCommentEvent: undefined,
  links: undefined,
  lists: undefined,
  lockQualifyingDeductionCalculation: undefined,
  name: undefined,
  organisationNumber: undefined,
  owningUser: undefined,
  paymentPeriod: undefined,
  phone1: undefined,
  phone2: undefined,
  phone3: undefined,
  phone4: undefined,
  places: undefined,
  primaryEmail: undefined,
  privacy: undefined,
  profileImage: undefined,
  prospect: undefined,
  rating: undefined,
  recruitmentStatus: undefined,
  relatedBookings: undefined,
  reportedPeriods: undefined,
  resourceReportedPeriods: undefined,
  score: undefined,
  secondaryEmail: undefined,
  secret: undefined,
  services: undefined,
  smsOptOut: undefined,
  socialSecurityNumber: undefined,
  status: undefined,
  taxRate: undefined,
  timeReportNotificationByEmail: undefined,
  timeReportNotificationBySms: undefined,
  unconfirmedBookedPeriods: undefined,
  updatedAt: undefined,
  useSelfInvoicing: undefined,
  vatNumber: undefined,
  workerType: undefined,
  assumedAvailableWeekdays: undefined,
  resourceNumber: undefined,
  gender: undefined,
  smsLoginEnabled: undefined,
  sharedFiles: undefined,
  recruitmentAdApplications: undefined,
  latestAgreement: undefined,
}) {
}
